import React from "react";

import CustomCheckbox from "../../../inputs/CustomCheckbox";

const RowComponent = ({ row, componentsPicked, handlePickedComponent }) => {
  const checked = componentsPicked.includes(row.id);

  return (
    <div className="components-row flex align-center pointer" onClick={() => handlePickedComponent(row)}>
      <div className="components-row-checkbox flex-center">
        <CustomCheckbox
          checked={checked}
          handleChange={() => handlePickedComponent(row)}
          customClass="components-checkbox"
        />
      </div>

      <div className="components-row-name flex">
        <span className="components-row-text">{row.name}</span>
      </div>

      <div className="components-row-type flex">
        <span className="components-row-text">{row.internal ? "internal" : "external"}</span>
      </div>

      <div className="components-row-description flex">
        <span className="components-row-text">{row.description}</span>
      </div>

      <div className="components-row-attributes flex">
        <span className="components-row-text">{row.countAttributes}</span>
      </div>

      <div className="components-row-importance flex">
        <span className="components-row-text">{row.importance}</span>
      </div>

      <div className="components-row-product flex">
        <span className="components-row-text">{row.productName}</span>
      </div>
    </div>
  );
};

export default RowComponent;
